import { FC, Fragment } from 'react';
import { Box, Chip, Divider, Grid, IconButton, Typography } from '@mui/material';
// components
import { CloseIcon } from 'assets/svgs';
import SelectController from 'controller/Select';
import CheckboxController from 'controller/Checkbox';
import InputController from 'controller/InputController';
// constants, interfaces, graphql, helper
import { formatValue, getPotencyValues } from 'lib/helper';
import { SelectType, IngredientFieldsProps } from 'interfaces';
import {
  TYPE_TEXT,
  UNIT_TEXT,
  VALUE_TEXT,
  OVERAGE_TEXT,
  POTENCY_TEXT,
  INACTIVE_TEXT,
  LABEL_CLAIM_TEXT,
  UNIT_SELECT_MAPPED,
  SHOW_CFU_TEXT,
} from 'constants/index';

const IngredientFields: FC<IngredientFieldsProps> = ({
  item,
  index,
  xl,
  onRemove,
  formulationType,
  isFactBox,
}) => {
  const { name, ingredientPotency, isActive } = item || {};
  const potencyObj: SelectType[] = getPotencyValues(ingredientPotency ?? 1);

  return (
    <Grid container spacing={2}>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        <Box display="flex" alignItems="center">
          <Typography variant="body2" color={isActive ? 'primary.main' : 'error'} fontWeight={600} flex={1}>
            {name}
            {!isActive && (
              <Chip
                sx={{ ml: 1 }}
                size="small"
                variant="outlined"
                label={formatValue(INACTIVE_TEXT)}
                color="error"
              />
            )}
          </Typography>
          <Box mx={1}>
            <IconButton onClick={() => onRemove(index)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Grid>
      <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
        <InputController
          isRequired
          fieldType="number"
          name={`formulaIngredients.${index}.value`}
          title={`${VALUE_TEXT} (${LABEL_CLAIM_TEXT})`}
        />
      </Grid>
      <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
        <SelectController
          isRequired
          title={UNIT_TEXT}
          options={UNIT_SELECT_MAPPED}
          name={`formulaIngredients.${index}.unit`}
        />
      </Grid>
      <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
        <SelectController
          title={`${POTENCY_TEXT} %`}
          options={potencyObj}
          name={`formulaIngredients.${index}.potency`}
        />
      </Grid>
      <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
        <InputController
          fieldType="number"
          name={`formulaIngredients.${index}.overage`}
          title={`${OVERAGE_TEXT} %`}
        />
      </Grid>

      {isFactBox ? (
        <Fragment />
      ) : (
        <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
          <SelectController
            isRequired
            title={TYPE_TEXT}
            options={formulationType}
            name={`formulaIngredients.${index}.type`}
          />
        </Grid>
      )}

      <Grid item xl={xl} lg={6} md={6} sm={12} xs={12}>
        <CheckboxController title={SHOW_CFU_TEXT} name={`formulaIngredients.${index}.showCfu`} />
      </Grid>
      <Grid item xl={12} lg={12} md={12} sm={12} xs={12} marginY={2}>
        <Divider />
      </Grid>
    </Grid>
  );
};

export default IngredientFields;
